import React from 'react';
import { PopupDialog } from 'swag-client-common/components/info/popup-dialog';
import { Button, ButtonType } from 'swag-client-common/components/ui/button';
import classes from './debossed-embelishment-method-popup.scss';
export const DebossedEmbelishmentMethodPopup = ({
  open,
  methodId,
  onClose
}) => {
  const content = /*#__PURE__*/React.createElement("div", {
    className: classes.content
  }, /*#__PURE__*/React.createElement("p", {
    className: classes.paragraph
  }, "This means that your artwork will be stamped in without color. After you place your order, we will send you a virtual mock-up so you can approve the design before it goes into production."), /*#__PURE__*/React.createElement(Button, {
    dataButton: "Continue",
    className: classes.button,
    type: ButtonType.primary,
    onClick: () => onClose(methodId)
  }, "Continue"));
  return /*#__PURE__*/React.createElement(PopupDialog, {
    title: "Keep in mind, your design will not be printed in color!",
    dataPopup: "DebossedEmbellishmentMethodPopup",
    titleClasses: {
      root: classes.header
    },
    content: content,
    onClose: () => onClose(methodId),
    showCloseButton: true,
    open: open,
    isResponsive: true
  });
};